import styles from "./Image.module.css";

function Image({ src, customStyle = {}, alt }) {
	return (
		<div className={styles.imageContainer}>
			<img
				src={src}
                style={customStyle}
				alt={alt}
			/>
		</div>
	);
}

export default Image;
